export default __webpack_public_path__ + "static/media/company_r1.15d33cb7.jpg";